/**
 * Periodic keepalive to reset Devise timeoutable last_request_at while the tab is visible.
 */

const DEFAULT_INTERVAL_MINUTES = 20

export function readKeepaliveIntervalMs() {
  if (typeof document === "undefined") return DEFAULT_INTERVAL_MINUTES * 60 * 1000

  const raw = document.body?.dataset?.sessionKeepaliveMinutes
  if (raw === "0" || raw === "false" || raw === "off") return null

  const minutes = parseInt(raw || String(DEFAULT_INTERVAL_MINUTES), 10)
  if (!Number.isFinite(minutes) || minutes <= 0) return null
  return minutes * 60 * 1000
}

export function startSessionKeepalive({ fetchImpl = fetch, profilePath = "/api/v1/profile" } = {}) {
  const intervalMs = readKeepaliveIntervalMs()
  if (intervalMs == null) return () => {}

  let timerId = null

  const ping = () => {
    if (typeof document !== "undefined" && document.visibilityState !== "visible") return
    fetchImpl(profilePath, {
      method: "GET",
      credentials: "include",
      headers: { Accept: "application/json" },
    }).catch(() => {})
  }

  timerId = window.setInterval(ping, intervalMs)

  return () => {
    if (timerId != null) window.clearInterval(timerId)
  }
}

export function installSessionKeepalive() {
  if (typeof window === "undefined" || window.__legacySessionKeepaliveInstalled) return
  window.__legacySessionKeepaliveInstalled = true
  startSessionKeepalive()
}
